import React from "react";
import Loader from "../../../../Components/Atoms/Loader/Loader";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import { getSupportedLanguages } from "../../../../Contexts/APIs/Lookups/SupportedLanguages";
import { toast } from "react-toastify";
import FAQDetailsTemplate from "../../../../Templates/Main/Documents/FAQ/FAQDetails.template";
import { getFAQDetails, updateFAQ } from "../../../../Contexts/APIs/FAQ/FAQ";

function FAQDetailsPage({roles}) {
  const navigate = useNavigate();

  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const [data, setData] = useState({});
  const [openLoader, setOpenLoader] = useState(false);
  const [supportedLanguages, setSupportedLanguages] = useState([]);
  const [supportLang, setSupportLang] = useState("en");

  const getFAQ = async () => {
    setOpenLoader(true);
    const { res, err } = await getFAQDetails(id);
    if (res) {
      setData(res?.data?.faq);
    }
    if (err) {
      toast.error(err);
    }
    setOpenLoader(false);
  };

  const getLanguages = async () => {
    const { res, err } = await getSupportedLanguages();
    if (res) {
      setSupportedLanguages(res?.data?.supported_locales);
    }
  };

  useEffect(() => {
    id && getFAQ(id);
  }, [id]);
  useEffect(() => {
    getLanguages({});
  }, []);
  const updateSupportedLang = (e, languages) => {
    setSupportLang(e.target.value);
  };
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const handleDeleteRequest = async () => {
    const action = () => navigate("/faqs");

    updateFAQ({
      id: id,
      data: {
        faq: { is_deleted: true },
      },
      action,
    });
  };
  return (
    <>
      <Loader open={openLoader} />
      <FAQDetailsTemplate
        data={data}
        supportedLanguages={supportedLanguages}
        updateSupportedLang={updateSupportedLang}
        supportLang={supportLang}
        openDeleteModal={openDeleteModal}
        setOpenDeleteModal={setOpenDeleteModal}
        handleDeleteRequest={handleDeleteRequest}
        roles={roles}
      />
    </>
  );
}

export default FAQDetailsPage;
